import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
// material

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  height: '100vh',
  width: '100%',
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
}));

// ----------------------------------------------------------------------

EmptyContentChat.propTypes = {
  title: PropTypes.string.isRequired,
  img: PropTypes.string,
  description: PropTypes.string
};

export default function EmptyContentChat({ title, description, img, ...other }) {
  return (
    <RootStyle
      className='bg-gradient-to-br from-neutral-100 to-white dark:from-[#111111] dark:to-[#0D0D0D]'
      {...other}>
      <Box
        component="img"
        alt="empty content"
        src={img || '/static/illustrations/illustration_empty_content.svg'}
        sx={{ height: 240, mb: 3 }}
      />

      <Typography variant="h5" gutterBottom sx={{ color: 'text.primary' }}>
        {title}
      </Typography>

      {description && (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      )}
    </RootStyle>
  );
}
